/* PastéBCN — Best sellers
   Web Component <pb-best-sellers> con IntersectionObserver para animar la entrada
   en viewport (cabecera + tarjetas con stagger). Respeta prefers-reduced-motion. */

if (!customElements.get('pb-best-sellers')) {
  class PbBestSellers extends HTMLElement {
    connectedCallback() {
      this._setupSectionLink();

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.reducedMotion) {
        this.classList.add('is-visible');
        return;
      }

      if (typeof IntersectionObserver === 'undefined') {
        this.classList.add('is-visible');
        return;
      }

      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.classList.add('is-visible');
              this._observer.disconnect();
            }
          });
        },
        { threshold: 0.15 }
      );
      this._observer.observe(this);
    }

    _setupSectionLink() {
      const url = this.dataset.sectionLink;
      if (!url || this._sectionLinkBound) return;
      this._sectionLinkBound = true;
      this.classList.add('is-linkable');
      this._onSectionClick = (event) => {
        // Los clicks sobre enlaces/botones reales (tartas, CTA) mandan.
        if (event.target.closest('a, button')) return;
        // No secuestrar cmd/ctrl/shift-click ni la selección de texto.
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (window.getSelection && String(window.getSelection())) return;
        window.location.href = url;
      };
      this.addEventListener('click', this._onSectionClick);
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
      if (this._onSectionClick) {
        this.removeEventListener('click', this._onSectionClick);
        this._onSectionClick = null;
      }
      this._sectionLinkBound = false;
    }
  }

  customElements.define('pb-best-sellers', PbBestSellers);
}
